import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../../util/event-bus-util'
import { logger } from '../../util/logger'
import { LoadingSpinner } from '../util/spinner/loading-spinner'
import { tokenService } from '@grndhouse/react-common'
import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'

export const LogoutRedirect = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    setIsLoading(true)
    tokenService
      .clear()
      .then(() => {
        eventBusUtil().emit({
          action: EventBusActionType.REMOVE,
          entity: EventBusEntityType.ACCESS_TOKEN,
          meta: {}, // TODO check if this is needed on web-app
        })
        setIsLoading(false)
      })
      .catch((err: Error) => {
        logger.error(err)
        setIsLoading(false)
      })
  }, [])
  return (
    <LoadingSpinner isLoading={isLoading}>
      <Redirect to="/login" />
    </LoadingSpinner>
  )
}
